import React, { useEffect, useState } from "react";
import { Modal, Button, Form, Spinner } from "react-bootstrap";
import { useMutation, useQuery } from "react-query";
import { toast } from "react-toastify";
import {
  postGovernatores,
  showGovernorates,
  updateGovernatores,
} from "../../../../MyApi/admin/governorates";
import { getCountries } from "../../../../MyApi/admin/countries/countries";
import i18next from "i18next";
import SkeletonWrapper from "../../../UI/skeletonWrapper";
import LoadingSpinner from "../../../UI/spinner";

const AddGovernorateModal = ({
  show,
  onClose,
  refetch,
  modalMode,
  modalId,
}) => {
  const [selectedLangCode, setSelectedLangCode] = useState(""); 
   const [formData, setFormData] = useState({
    name: "",
    country_id: "",
  });
  const currentLang =i18next.language
  const { data: governoratesData, isLoading } = useQuery(
    ["showGovernorate", modalId, selectedLangCode],
    () => showGovernorates(modalId, selectedLangCode),
    {
      enabled: modalMode === "edit" && !!modalId,
    }
  );
  const { data } = useQuery("getcountries", () => getCountries());

  const countries = data?.data.countries || [];
  const governorates = governoratesData?.data.governorate || {};

  useEffect(() => {
    if (modalMode === "edit" && governorates) {
      setFormData((prev) => ({
        ...prev,
        name: governorates?.name,
        country_id: governorates?.country?.id,
      }));
      console.log("country");
    }
  }, [governorates]);
  useEffect(() => {
    if (modalMode === "edit") {
     
      console.log("currentLang", currentLang);
      setSelectedLangCode(currentLang);
    }
  }, []);
  const mutation = useMutation({
    mutationKey: ["postGovernorate"],
    mutationFn: (postData) => postGovernatores(postData),
    onSuccess: (data) => {
      toast.success(data.message || "تم إضافة المحافظة بنجاح");
      onClose("governorate");
      refetch();
    },
    onError: (error) => {
      toast.error(error.response?.data?.message || "حدث خطأ أثناء الإضافة");
    },
  });  
  const mutationUpdate = useMutation({
    mutationKey: ["updateGovernorate"],
    mutationFn: (postData) => updateGovernatores(postData ,currentLang,modalId),
    onSuccess: (data) => {
      toast.success(data.message || "تم إضافة المحافظة بنجاح");
      onClose("governorate");
      refetch();
    },
    onError: (error) => {
      toast.error(error.response?.data?.message || "حدث خطأ أثناء الإضافة");
    },
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleLangChange = (e) => {
    setSelectedLangCode(e.target.value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formData.name || !formData.country_id) {
      toast.error("من فضلك أكمل جميع الحقول");
      return;
    }

    if (modalMode === "edit") {
    const updatedFormData ={
  ...formData,
        _method: "PUT",
        lang: selectedLangCode,
    }
      
 

      mutationUpdate.mutate(updatedFormData);
    } else {
      mutation.mutate(formData);
    }
  };

  return (
    <Modal show={show} onHide={() => onClose("governorate")} centered>
      <Form onSubmit={handleSubmit} className="add">
        <Modal.Header closeButton>
          <Modal.Title>
            {modalMode === "edit" ? "تعديل" : "إضافة"} محافظة جديدة
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <p className="text-muted small mb-3">أضف محافظة جديدة لدايم</p>
            {modalMode ==="edit"&&
            <div>
              <label htmlFor="">اللغة</label>
                <select className="form-control" onChange={handleLangChange} value={selectedLangCode}>
              <option value="ar">العربية</option>
              <option value="en">English</option>
              </select>
            </div>
          }
      

          <Form.Group className="mb-3">
            <Form.Label>اسم المحافظة</Form.Label>
                        <SkeletonWrapper isLoading={isLoading}>
                                <Form.Control
              type="text"
              name="name"
              placeholder="ادخل اسم المحافظة"
              value={formData.name}
              onChange={handleChange}
              />
                        </SkeletonWrapper>
      
          </Form.Group>
              

          <Form.Group className="mb-3">
            <Form.Label>الدولة</Form.Label>
                 <SkeletonWrapper isLoading={isLoading}>

            <Form.Select
              name="country_id"
              value={formData.country_id}
              onChange={handleChange}
              >
              <option value="">اختر الدولة</option>
              {countries.map((country) => (
                <option key={country.id} value={country.id}>
                  {country.name}
                </option>
              ))}
            </Form.Select>
              </SkeletonWrapper>
          </Form.Group>
        </Modal.Body>

        <Modal.Footer className="justify-content-start">
          <Button variant="primary" type="submit">
            {mutation.isLoading ||mutationUpdate.isLoading ? (
              <Spinner />
            ) : modalMode === "edit" ? (
              "تعديل محافظة"
            ) : (
              " إضافة محافظة"
            )}
          </Button>
          <button
            className="btn btn-white "
            disabled={mutation.isLoading || mutationUpdate.isLoading}
            onClick={() => onClose("governorate")}
          >
            إلغاء
          </button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default AddGovernorateModal;
